import type { Props as MenuProps } from 'site/components/header/Menu.tsx'
import Cart from 'site/components/minicart/Cart.tsx'
import Drawer from 'site/components/ui/Drawer.tsx'
import { displayCart, displayMenu, useUI } from 'site/sdk/useUI.ts'
import { effect } from '@preact/signals'
import type { ComponentChildren } from 'preact'
import { Suspense } from 'preact/compat'
import Menu from 'site/components/header/Menu.tsx'

export interface Props {
    menu: MenuProps
    /**
     * @ignore_gen true
     */
    children?: ComponentChildren
    /**
     * @ignore_gen true
     */
    checkoutUrl: string
    couponMessages?: string
}

const Aside = ({
    children,
}: {
    children: ComponentChildren
}) => (
    <div class='h-full lg:h-[799px] max-h-screen w-full lg:max-w-[433px] bg-white'>
        <Suspense
            fallback={
                <div class='w-screen flex items-center justify-center relative'>
                    <span class='loading loading-ring' />
                </div>
            }
        >
            {children}
        </Suspense>
    </div>
)

let lastKnownPosition = 0

effect(() => {
    if (!globalThis.document || globalThis.innerWidth >= 768) return

    let timeoutId: undefined | number = undefined

    if (displayCart.value || displayMenu.value) {
        lastKnownPosition = globalThis.scrollY
        timeoutId = setTimeout(() => {
            document.body.setAttribute('style', 'overflow: hidden !important; height: 100vh')
            const html = document.querySelector('html')
            if (html) html.setAttribute('style', 'overflow: hidden !important; height: 100vh')
        }, 200)
    } else {
        document.body.removeAttribute('style')

        const html = document.querySelector('html')

        if (html) html.removeAttribute('style')

        if (lastKnownPosition) {
            if (timeoutId) clearTimeout(timeoutId)
            globalThis.scrollBy({ top: lastKnownPosition, left: 0, behavior: 'instant' })
            lastKnownPosition = 0
        }
    }
})

function Drawers({ menu, children, checkoutUrl, couponMessages }: Props) {
    const { displayCart, displayMenu } = useUI()

    return (
        <Drawer // left drawer
            asideId='mobile-menu'
            open={displayMenu.value}
            loading='eager' // force menu to load eagerly to avoid issues
            onClose={() => {
                displayMenu.value = false
            }}
            aside={<Aside>{<Menu {...menu} />}</Aside>}
        >
            <Drawer // right drawer
                class='drawer-end'
                open={displayCart.value}
                onClose={() => {
                    displayCart.value = false
                }}
                aside={
                    <Aside>
                        <Cart {...menu} checkoutUrl={checkoutUrl} couponMessages={couponMessages} />
                    </Aside>
                }
            >
                {children}
            </Drawer>
        </Drawer>
    )
}

export default Drawers
